import '../node_modules/@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import '@app/styles.css';
import '@app/overrides/buyer.css';
import '@app/overrides/product.css';
import '@app/overrides/shell.css';
import './translations/i18n';

import App from '@app/app';
import { restoreSession } from '@lib/auth/session';
import { queryClient } from '@lib/queryClient';
import { AppStoreProvider } from '@lib/store';
import { QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';

if (process.env.NODE_ENV === 'development') {
  const resizeObserverErrors = new Set([
    'ResizeObserver loop completed with undelivered notifications.',
    'ResizeObserver loop limit exceeded',
  ]);

  window.addEventListener('error', (event: ErrorEvent) => {
    const message = event.message || '';
    if (resizeObserverErrors.has(message)) {
      event.stopImmediatePropagation();
    }
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root was not found');
}

const root = ReactDOM.createRoot(rootElement);

const renderApp = (): void => {
  root.render(
    <AppStoreProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </AppStoreProvider>
  );
};

const sessionRestore = restoreSession();
const sessionRestoreTimeout = new Promise<void>((resolve) => {
  window.setTimeout(resolve, 4000);
});

void Promise.race([sessionRestore, sessionRestoreTimeout]).finally(renderApp);
